<div class="table-container">
    <div id="mainDiv">
        <div class="p-iconField">
            <p-iconField iconPosition="right">
                <p-inputIcon class="icon-search-button" styleClass=" pi pi-search" (click)="search()" />
                <input class="input-field" [(ngModel)]="searchCodigo" (keydown)="onKeyDown($event)" type="text"
                    pInputText [placeholder]="placeholders.pesquisar_codigo" />
            </p-iconField>
        </div>

        <p-calendar [(ngModel)]="rangeDates" selectionMode="range" [readonlyInput]="true"
            [placeholder]="placeholders.pesquisar_data" />
        <p-button styleClass="button-adicionar-x" [label]="botoes.buscar" icon="pi pi-search" (click)="search()" />
    </div>
    <p-table [value]="itens" class="table-style" [customSort]="true">
        <ng-template class="ct-tr" pTemplate="header">
            <tr>
                <th>#</th>
                <th>{{headers.imagem}}</th>
                <!-- <th>Codigo Item</th> -->
                <th>{{headers.barras}}</th>
                <th>{{headers.nome}}</th>
                <th>{{headers.preco_venda}}</th>
                <th>{{headers.tipo_imposto}}</th>
                <th>{{headers.custo}}</th>
                <th>{{headers.saldo}}</th>
                <th>{{headers.tipo_item}}</th>
                <th>{{headers.acoes}}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
            <tr>
                <td>{{ item.id }}</td>
                <td>{{ item.imagem }}</td>
                <!-- <td>{{ item.codigoItem }}</td> -->
                <td>{{ item.barras }}</td>
                <td>{{ item.nome }}</td>
                <td>{{ item.precoDeVenda }}</td>
                <td>{{ item.tipoDeImposto }}</td>
                <td>{{ item.custo }}</td>
                <td>{{ item.saldo }}</td>
                <td>{{ item.tipoItem }}</td>
                <td>
                    <div class="table-actions">
                        <p-button icon="pi pi-download" [label]="botoes.baixar_pdf" (click)="selectItem(item)"> </p-button>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>

    <div class="pagination-container">
        <p-paginator (onPageChange)="onPageChange($event)" [showCurrentPageReport]="true"
            currentPageReportTemplate="{first} - {last} de {totalRecords}" [first]="first" [rows]="rows"
            [totalRecords]="totalRecords" [showFirstLastIcon]="true">
        </p-paginator>

        <span class="mx-1 text-color">{{texts.itens_por_pagina}} </span>
        <p-dropdown [options]="options" optionLabel="label" optionValue="value" [(ngModel)]="rows"
            (ngModelChange)="onRowsPerPageChange()"></p-dropdown>
    </div>
</div>
